import React, { useState, memo } from 'react';
import { Row, Col, Collapse } from 'reactstrap';
import classNames from 'classnames';

import SectionContainer from 'components/sectionContainer';
import CircularArrow from 'components/circularArrow';
import { Title } from 'components/typography';
import { useMarketData } from 'context/market';
import { slugify } from 'helpers';

import {
  ourCommoditiesContainer,
  commoditiesList,
  commodityItemButton,
  commodityDetails,
  activeItem,
  buttonArrow,
  imageContainer,
  commodityName,
  commoditySectionTitle,
  image,
  imageLoading,
  imageLoaded,
} from './scss/OurCommodities.module.scss';

const OurCommodities = () => {
  const { commodities } = useMarketData();
  const defaultCommodity = commodities[0];
  const [activeCommodity, setActiveCommodity] = useState(defaultCommodity);
  const [loadedImageID, setLoadedImageID] = useState(
    slugify(defaultCommodity.name)
  );

  const handleImageLoad = commodityID => {
    setLoadedImageID(commodityID);
  };

  return (
    <SectionContainer name="ourCommodities">
      <div className={ourCommoditiesContainer}>
        <div>
          <div className={commoditySectionTitle}>
            <Title
              value={
                <>
                  We provide market participants a platform to carry{' '}
                  <br className="d-none d-lg-block" />
                  out trades seamlessly
                </>
              }
              size="xl"
            />
          </div>
          <Row noGutters>
            <Col lg="4">
              <div className={commoditiesList}>
                <header>
                  <Title value="Commodities we trade" size="lg" />
                </header>
                {commodities.map(commodity => {
                  const commodityID = slugify(commodity.name);
                  const isActive = activeCommodity.name === commodity.name;
                  return (
                    <div key={commodityID}>
                      <button
                        name={commodity.name}
                        onClick={() => setActiveCommodity(commodity)}
                        className={classNames(
                          commodityItemButton,
                          isActive && activeItem
                        )}
                        id={commodityID}
                      >
                        <CircularArrow className={buttonArrow} />
                        <Title value={commodity.name} size="sm" />
                      </button>
                      <Collapse
                        isOpen={isActive}
                        className={classNames(commodityDetails, 'd-lg-none')}
                      >
                        <div className={imageContainer}>
                          <img
                            key={commodityID}
                            src={activeCommodity.image}
                            alt={activeCommodity.name}
                          />
                        </div>
                        <p>{activeCommodity.description}</p>
                      </Collapse>
                    </div>
                  );
                })}
              </div>
            </Col>
            <Col lg="8">
              <div className="d-none d-lg-block">
                <div className={imageContainer}>
                  <img
                    src={activeCommodity.image}
                    alt={activeCommodity.name}
                    onLoad={() =>
                      handleImageLoad(slugify(activeCommodity.name))
                    }
                    className={classNames(
                      image,
                      slugify(activeCommodity.name) === loadedImageID
                        ? imageLoaded
                        : imageLoading
                    )}
                  />
                </div>
                <Title value={activeCommodity.name} className={commodityName} />
                <p>{activeCommodity.description}</p>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </SectionContainer>
  );
};

OurCommodities.propTypes = {};

OurCommodities.defaultProps = {};

export default memo(OurCommodities);
